import { createCompoundComponent } from '../../utilities'

import { TestimonialCard as BaseTestimonialCard } from './TestimonialCard'
import { Author } from './components/Author'
import { Avatar } from './components/Avatar'
import { MetaText } from './components/MetaText'
import { Name } from './components/Name'
import { Title } from './components/Title'
import { DateText } from './components/DateText'
import { Quote } from './components/Quote'

export type { TestimonialCardProps } from './types'

export const TestimonialCard = createCompoundComponent(BaseTestimonialCard, {
  Author,
  Avatar,
  MetaText,
  Name,
  Title,
  Date: DateText,
  Quote,
})
